import React from "react";

export default ({ show }: any) => {
  return (
    <svg
      style={{ rotate: show && "180deg" }}
      width="7"
      height="4"
      viewBox="0 0 7 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.93432 0H0.846926C0.441219 0 0.238039 0.567978 0.524918 0.90016L3.06862 3.84556C3.24646 4.05148 3.53479 4.05148 3.71263 3.84556L6.25633 0.900161C6.54321 0.567979 6.34003 0 5.93432 0Z"
        fill="var(--color-filter-modal-item, #393B42)"
      />
    </svg>
  );
};
